import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import EnotesChapterTable from './EnotesChapterTable';
const EnoteChapter = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Enotes Chapter' parent='Enotes Chapter'  />
      <Container fluid={true}>
        <Row>
          <EnotesChapterTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default EnoteChapter;
